import translations from './translations.json';
const isValidLanguage = (lang) => {
    if (['sv', 'en', 'de'].find(f => f === lang)) {
        return ['sv', 'en', 'de'].find(f => f === lang);
    }

    return false;
};

const hasTranslation =  (defaultText, key, locale) => {
    return translations[key] && translations[key][defaultText] && translations[key][defaultText][locale] ? translations[key][defaultText][locale] : defaultText;
};

export const getTranslation = (defaultText, key) => {
    let locale = 'sv';
    //Try get locale from editor settings
    if (typeof editorSettings !== 'undefined' && editorSettings.currentLang) {
        locale = editorSettings.currentLang.locale;
        return  hasTranslation(defaultText, key, locale);
    }

    //Try get locale from url
    if (window.document.location.pathname && isValidLanguage(window.location.pathname.substring(1,3))) {
        locale = isValidLanguage(window.location.pathname.substring(1,3));
        return  hasTranslation(defaultText, key, locale);
    }

    return defaultText;
};